<template>
  <v-container class="trad-editor">
    <v-row>
      <v-col cols="12" xl="3" class="pa-0">
        <span v-if="debug" class="debug-panel">
          {{ onlyread }}<br/>
          {{ dirtyIndex}}<br/>
          {{  ctx.state  }} <br/>
          {{  setting }}<br/>
          {{  start }} -- {{ end }} -- {{  duration }}
        </span>
        <!-- <v-select
          v-if="!onlysurf && tune.recordings.length > 1"
          :items="tune.recordings"
          item-text="title"
          hide-details
          v-model="recording"
          label="Available recordings"
          item-value="id"
        >
        </v-select> -->
        <v-row v-if="!onlysurf">
          <custom-slider
            :value="volume"
            @input="v => volume = v"
            :min="0"
            :max="100"
            :step="1"
            prepend-icon="mdi-volume-high"
            cols="9"
            col-class="d-flex justify-start align-center"
          />
           <v-col cols="3">
             <span
             class="text-h5 font-weight-light"
             v-text="''+volume + '%'"
             ></span>
           </v-col>
          <custom-slider
            :value="shifter"
            @input="v => shifter = v"
            :min="-12"
            :max="12"
            :step="0.1"
            prepend-icon="mdi-music-clef-treble"
            cols="9"
          />
           <v-col cols="3">
             <span
             class="text-h5 font-weight-light"
             >
             <span v-if="shifter>0">+</span>{{ shifter }}
           </span>
         </v-col>
          <custom-slider
            :value="speed"
            @input="v => speed = v"
            :min="0.1"
            :max="2"
            :step="0.05"
            prepend-icon="mdi-play-speed"
            cols="9"
        />
         <v-col cols="3">
           <span
           class="text-h5 font-weight-light"
           >
           {{ speed }}x
         </span>
       </v-col>
      <v-col cols="6">
         <v-text-field
           disabled
           label="Start"
           class="bounds"
           x-small
           dense
           hide-details
             prepend-inner-icon="mdi-contain-start"
           step="0.01"
           v-model="start"
         ></v-text-field>
       </v-col>
       <v-col cols="6">
         <v-text-field
           label="End"
           class="bounds"
           x-small
           dense
           hide-details
           disabled
           append-outer-icon="mdi-contain-end"
           step="0.01"
           v-model="end"
         ></v-text-field>
       </v-col>
       <v-col cols="12 d-flex flex-column justify-center align-center">
         <v-btn block v-if="dirty" color="info" @click="saveSetting">
           <v-icon small>mdi-content-save</v-icon>
           Save
         </v-btn>
       </v-col>
     </v-row>
       </v-col>
       <v-col cols="12" :lg="onlysurf ? 12 : 9" class="pa-0">
         <v-row v-if="!onlysurf" class="d-none">
           <v-col cols="3">
             <v-text-field
               type="number"
               step="0.01"
               v-model="start"
             ></v-text-field>
           </v-col>
           <v-col cols="6">
             <v-slider
               v-model="zoom"
               min="10"
               max="1000"
               step="1"
             ></v-slider>
           </v-col>
           <v-col cols="3">
             <v-text-field
               type="number"
               step="0.01"
               v-model="end"
             ></v-text-field>
           </v-col>
         </v-row>
         <div ref="surf-wrap" :class="['surf-wrap',{ 'loading': !surferLoaded, 'tall': !onlysurf }]">
           <div class="loader" v-if="!surferLoaded"></div>
         </div>
       </v-col>
     </v-row>
   </v-container>
 </template>

 <script>
import * as Tone from "tone";
import { guess } from 'web-audio-beat-detector';
import WaveSurfer from 'wavesurfer.js'
import RegionsPlugin from 'wavesurfer.js/dist/plugins/regions.esm.js'
import CustomSlider from './CustomSlider.vue'

 function defaultPlayerSettings(duration) {
   return {
     start: 0,
     end: Math.floor(100 * duration) / 100,
     volume: 80,
     pitch: 0,
     speed: 1
   }
 }

 export default {
   name: 'TradEditor',
   components: { CustomSlider },
   data: function () {
     return {
       playing: false,
       start: null,
       dirty: false,
       dirtyIndex: 0,
       end: null,
       speed: 1,
       height: 256,
       bpm: null,
       surfer: null,
       surferLoaded: false,
       player: null,
       shifter: 0,
       volume: 80,
       frqShft: null,
       gain: null,
       audio: null,
       zoom: 100,
       toneStatus: null,
       regions: null,
     }
   },
   props: ['setting', 'ctx', 'innerHeight', 'onlysurf', 'debug','onlyread', 'recording'],
   mounted() {
      this.initCtx();
   },
   methods: {
     buildSurfer() {
       this.initCtx();
     },
     async initCtx() {
       Tone.setContext(this.ctx)
       const fileUrl = this.recording.file;

       // Try to load from cache first
       const cache = await caches.open('mp3-cache-v1');
       const cachedResponse = await cache.match(fileUrl);
       let audioBlob;

       if (cachedResponse) {
         console.log('Loaded MP3 from cache:', fileUrl);
         audioBlob = await cachedResponse.blob();
       } else {
         console.log('Fetching and caching MP3:', fileUrl);
         const response = await fetch(fileUrl, { mode: 'cors' });
         const responseForCache = response.clone(); // clone BEFORE reading the body
         audioBlob = await response.blob();
         await cache.put(fileUrl, responseForCache);
       }

       const audioUrl = URL.createObjectURL(audioBlob);
       this.audio = new Audio(audioUrl);
       this.audio.controls = true;
       this.audio.crossOrigin = "anonymous";
       // if resource came from cache we already set blob URL; otherwise keep the object URL for playback
       if (!cachedResponse) this.audio.src = this.recording.file;
       this.regions = RegionsPlugin.create()
       this.surfer = WaveSurfer.create({
         container: this.$refs['surf-wrap'],
         waveColor: 'rgba(0, 154, 68,0.5)',
         progressColor: 'rgba(0, 154, 68,0.5)',
         height: this.innerHeight,
         dragToSeek: false,
         cursorColor: 'rgba(255,136,62)',
         cursorWidth: 2,
         media: this.audio,
         plugins: [this.regions],
       });
       this.frqShft = new Tone.PitchShift(this.shifter).toDestination();
       this.audio.volume = this.volume / 80;
       // this.gain = new Tone.Gain(this.volume/100);
       this.player = this.ctx.createMediaElementSource(this.audio);
       Tone.connect(this.player, this.frqShft);
       // Tone.connect(this.gain, this.frqShft);
       this.surfer.on('ready', () =>
       {
         this.surferLoaded = true;
         if (!this.setting.player_settings.end) {
           this.start = 0;
           this.end = Math.floor(100 * this.surfer.renderer.audioData.duration) / 100;
           if (!this.onlyread) {
             this.$store.dispatch('tune/updateSetting', {
               setting_id: this.setting.id,
               data: {
                 player_settings: defaultPlayerSettings(this.surfer.renderer.audioData.duration)
               }
             }).then(this.buildRegions())
           }
           else {
             if (!this.onlyread)
               this.buildRegions();
           }

         }
         else {
           this.start = this.setting.player_settings.start;
           this.end = this.setting.player_settings.end;
           this.speed = this.setting.player_settings.speed;
           this.shifter = this.setting.player_settings.pitch;
           this.volume = this.setting.player_settings.volume;
           if (!this.onlyread)
             this.buildRegions();
         }
       });
       // this.regions.on('region-in', (region) => {
       //   // this.metronome.start();
       // })

     },
     getCurrentTime() {
       return this.surfer.getCurrentTime()
     },
     buildRegions() {
       this.regions.addRegion({
         start: this.start,
         end: this.end,
         content: '',
         color: 'rgba(0, 154, 68,0.25)',
         resize: true,
       });
       this.$emit('ready');
       this.regions.on('region-updated', (region) => {
         if (!this.playing)
           this.surfer.setTime(region.start);
         this.start = Math.floor(100 * region.start) / 100
         this.end = Math.floor(100 * region.end) / 100
         this.dirtyIndex++;
       })
       this.regions.on('region-out', () => {
         if (this.playing) {
           this.stop();
           this.$emit('end');
         }
         this.playing = false;
       })
       this.surfer.setTime(this.start);
     },
     play() {
       this.playing = true;
       if (this.onlyread)
         this.surfer.play();
       else
         this.surfer.plugins[0].regions[0].play();
     },
     stop() {
       this.playing = false;
       this.surfer.pause();
       // this.surfer.setTime(this.start);
     },
     gotoStart() {
       this.playing = false;
       this.surfer.stop();
     },
     togglePlay() {
       if (!this.playing)
         this.play();
       else {
         this.stop()
       }
     },
     songAnalyze() {
       guess(this.surfer.renderer.audioData)
         .then((tempo) => {
           this.bpm = tempo;
           this.bpm.interval = 60 / this.bpm.tempo
           this.buildRegions()
         })
         .catch(() => {
           this.bpm = null;
           this.buildRegions()
         });
     },
     saveSetting() {
       this.dirtyIndex = 0;
       this.$store.dispatch('tune/updateSetting', {
         setting_id: this.setting.id,
         data: this.playerSettings
       });
     }
   },
   computed: {
     tune() {
       return this.setting.tune;
     },
     duration() {
       return this.end-this.start
     },
     playerSettings() {
       return {
         start: this.start,
         end: this.end,
         volume: this.volume,
         pitch: this.shifter,
         speed: this.speed
       }
     }
   },
   beforeDestroy() {
     // stop playback and cleanup resources
     if (this.playing) this.stop();
     try {
       if (this.surfer && typeof this.surfer.destroy === 'function') this.surfer.destroy();
       if (this.audio) {
         this.audio.pause();
         if (this.audio.src) this.audio.src = '';
       }
       if (this.player && this.player.disconnect) this.player.disconnect();
       if (this.frqShft && this.frqShft.dispose) this.frqShft.dispose();
     } catch (e) { console.warn('cleanup error', e) }
   },
   watch: {
     playerSettings() {
       this.dirtyIndex++;
     },
     dirtyIndex(val) {
       if (val > 1) {
         this.dirty = true;
       }
       else {
         this.dirty = false;
       }
     },
     dirty(val) {
       this.$emit('dirty-status', val);
     },
     shifter(val) {
       this.frqShft.pitch = val;
     },
     speed(val) {
       this.surfer.setPlaybackRate(val, true);
     },
     volume(val) {
       this.audio.volume = val / 100;
     },
     playing(val) {
       this.$emit('play-status', val)
     },
     innerHeight(val) {
       let options = this.surfer.options;
       options.height = val;
       this.surfer.setOptions(options);
     },
     zoom(val) {
       this.surfer.zoom(val)
     }
   }
 }
 </script>
 
 <!-- Add "scoped" attribute to limit CSS to this component only -->
 <style lang="scss">
 .trad-editor {
   .surf-wrap {
     transition: height 0.5s ease-in-out;
     display: block;
     width: 100%;
     height: 32px;
     &.tall {
       height: 256px;
     }
 
     &.loading {
       background: rgba(0, 154, 68,0.25);
       
     }
   }
   .bounds {
     input {
       text-align: center;
     }
   }
 }
 /* HTML: <div class="loader"></div> */
 .loader {
   position: relative;
   top: 4px;
   left: 4px;
   width: 24px;
   aspect-ratio: 1;
   border-radius: 50%;
   border: 8px solid;
   border-color: rgba(255,255,255,1) rgba(255,255,255,0);
   animation: l1 1s infinite;
 }
 @keyframes l1 {to{transform: rotate(.5turn)}}
 </style>
